import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { ModuleForm } from "../ModuleForm";
import { CreateModuleModalProps } from "./types";
import { useCreateModuleModal } from "./controller";

export const CreateModuleModal = React.memo(({ modalRef, onRefetch }: CreateModuleModalProps) => {
  const translate = useTranslate();

  const { methods, handleConfirm, isPending } = useCreateModuleModal({
    modalRef,
    onRefetch,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("agreement_modules_admin.create_title")}
      onConfirm={handleConfirm}
      methods={methods}
      isPending={isPending}
    >
      <ModuleForm />
    </Modal>
  );
});
